<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { capitalizeStr } from '@Helpers';
import { useADialog } from '@Atoms';
import { useApplicationsStatus } from '@AdoptionModule';

const emits = defineEmits<{
  blur: [];
}>();

const props = defineProps<{
  isFormsAndApplications?: boolean;
  isEditingOnCell?: boolean;
  loading?: boolean;
  rowInfo?: any;
}>();

const { onOpenAdoptApplicationStatusModal, useOptions } = useApplicationsStatus();
const { activeModal, activeModalProps, dialogVisibility, SYSTEM_MODALS } = useADialog();

const _initialModelValue = ref(props.rowInfo.status);
const _model = ref(props.rowInfo.status);

const options = useOptions(props.isFormsAndApplications);

const applicationId = computed(() => {
  return props.isFormsAndApplications ? props.rowInfo?._id?.$oid : props.rowInfo?.application_id?.$oid;
});

watch(applicationId, () => (_model.value = props.rowInfo.status));

function openModal() {
  if (!props.isFormsAndApplications) {
    onOpenAdoptApplicationStatusModal(props.rowInfo, _model.value);
    emits('blur');
    return;
  }

  const checkModel = !_model.value || _model.value === _initialModelValue.value;
  if (checkModel) return;

  const { status, _id } = props.rowInfo;

  const modalProps = {
    applicationId: _id.$oid,
    oldStatus: status,
    status: _model.value,
  };

  activeModalProps.value = modalProps;
  activeModal.value = SYSTEM_MODALS.INDIVIDUAL_ADOPTION_APPLICATIONS;
  dialogVisibility.value = true;
  emits('blur');
}
</script>

<template>
  <Dropdown
    v-model="_model"
    showClear
    class="!h-9 !w-fit"
    optionLabel="label"
    optionValue="value"
    pt:input="flex items-center py-0.5 pr-0 pl-1 !text-xs text-gray-500 font-medium"
    pt:item="!overflow-x-hidden !text-sm"
    pt:list="!w-fit !max-w-none !px-0"
    :options
    :disabled="loading"
    :placeholder="$t('filters.changeApplicationStatus.title')"
    :virtualScrollerOptions="{ itemSize: 36 }"
    @change="openModal"
  >
    <template #clearicon>
      <Button
        outlined
        class="af-button border-none p-0 !text-slate-400"
        icon="pi pi-times"
        pt:icon="text-sm"
        @click="emits('blur')"
      />
    </template>

    <template #option="{ option }">
      <label class="cursor-pointer text-sm">{{ $t(option.label) }}</label>
    </template>

    <template #value="{ value }">
      <label class="cursor-pointer text-xs">{{ capitalizeStr(value) }}</label>
    </template>
  </Dropdown>
</template>
